module.exports = __webpack_public_path__ + "static/media/FiberousVeryThinRoot5.b8441445.PNG";